



































































































































































import { Component, Vue } from 'vue-property-decorator';
import { UserRole } from '@/resource/user/user.model';
import { getRole } from '@/utils/cookie';
import {
  createPreCollection,
  CreatePreCollectionParam,
  deletePreCollectionByUuid,
  getPreCollectionByUuid,
  updatePreCollectionByUuid,
} from '@/utils/pre-collection/pre-collection-util';
import getLevelPremadePaper, {
  PremadePaperLevel,
} from '@/utils/common/get-level-premade-paper';
import { getAllSubjects } from '@/utils/add-question/add-question-util';
import { Subject } from '@/resource/subject/subject.model';
import AddQuestionUpload from '@/components/add-question/AddQuestionUpload.vue';
import AddQuestionLoading from '@/components/add-question/AddQuestionLoading.vue';
import {
  PreCollection,
  PreCollectionThumbnail,
  PreCollectionType,
  preCollectionThumbnailList,
  preCollectionTypeList,
} from '@/resource/pre-collection/pre-collection.model';
import generatePrecollectionUrl from '@/utils/common/generate-precollection-url';
import { ErrorResponse } from '@/utils/response';

@Component({
  components: { AddQuestionUpload, AddQuestionLoading },
})
export default class AdminAddPreCollection extends Vue {
  get userRole(): UserRole | null {
    return getRole();
  }

  get preCollectionUuid() {
    return this.$route.params.uuid;
  }

  get preCollectionTypes(): PreCollectionType[] {
    return preCollectionTypeList;
  }

  get preCollectionThumbnails(): PreCollectionThumbnail[] {
    return [...preCollectionThumbnailList];
  }

  get availForms(): string[] {
    return [-2, -3, -4, -5, ...Array(11).keys()].map(i =>
      this.generateLevel(i + 1),
    );
  }

  availSubjects: Subject[] = [];
  currentPreCollection: PreCollection | null = null;

  get precollectionUrl() {
    if (this.currentPreCollection) {
      return generatePrecollectionUrl(this.currentPreCollection);
    } else {
      return '';
    }
  }

  get previewPreCollection() {
    const items = [];
    if (this.currentPreCollection) {
      this.currentPreCollection.id;
      this.currentPreCollection.id;

      const uuid = this.currentPreCollection.uuid;
      const name = this.currentPreCollection.name;
      const description = this.currentPreCollection.description;
      const details = this.currentPreCollection.details;
      const type = this.currentPreCollection.type;
      const thumbnail = this.currentPreCollection.thumbnail;
      const form = this.currentPreCollection.form;
      const year = this.currentPreCollection.year;
      const subjectUuid = this.currentPreCollection.subject.uuid;
      const pdfLink = this.currentPreCollection.pdfLink;
      const pdfLinkPreview = this.currentPreCollection.pdfLinkPreview;
      const totalQuestions = this.currentPreCollection.totalQuestions;
      const isPremium = this.currentPreCollection.isPremium;
      const collectionUuid = this.currentPreCollection.collection
        ? this.currentPreCollection.collection.uuid
        : '';

      this.collectionUuidInput = collectionUuid;
      this.nameInput = name;
      this.descriptionInput = description;
      this.detailsInput = details;
      this.typeInput = type;
      this.thumbnailInput = thumbnail;
      this.formInput = this.generateLevel(form);
      this.yearInput = year;
      this.subjectUuidInput = subjectUuid;
      this.pdfLinkInput = pdfLink;
      this.pdfLinkPreviewInput = pdfLinkPreview;
      this.totalQuestionsInput = totalQuestions;
      this.isPremium = isPremium ? 'Premium' : 'Free';

      return [
        { index: 'uuid', value: uuid },
        { index: 'name', value: name },
        { index: 'description', value: description },
        { index: 'details', value: details },
        { index: 'type', value: type },
        { index: 'form', value: form },
        { index: 'year', value: year },
        { index: 'subjectUuid', value: subjectUuid },
        { index: 'pdfLink', value: pdfLink },
        { index: 'collectionUuid', value: collectionUuid },
        { index: 'totalQuestions', value: totalQuestions },
      ];
    }

    return items;
  }

  nameInput = '';
  descriptionInput = '';
  detailsInput = '';
  typeInput = PreCollectionType.Exam;
  thumbnailInput = PreCollectionThumbnail.PERCUBAAN;
  formInput = this.generateLevel(9);
  yearInput = 2021;
  subjectUuidInput = 'sejarah';
  pdfLinkInput = '';
  pdfLinkPreviewInput = '';
  collectionUuidInput = '';
  isPremium = 'Free';
  totalQuestionsInput: number | null = null;

  isLoading = false;

  async created() {
    await this.fetchSubjects();

    if (this.preCollectionUuid) {
      await this.fetchPreCollection(this.preCollectionUuid);
    }
  }

  generateLevel(level: number) {
    return getLevelPremadePaper(level);
  }

  getLevel(level: string) {
    if (level === PremadePaperLevel.tahap1) {
      return -1;
    } else if (level === PremadePaperLevel.tahap2) {
      return -2;
    } else if (level === PremadePaperLevel.PT3) {
      return -3;
    } else if (level === PremadePaperLevel.SPM) {
      return -4;
    }

    const [levelType, levelNumber] = level.split(' ');

    if (levelType.trim() === 'Form') {
      return Number(levelNumber.trim()) + 6;
    } else {
      return Number(levelNumber.trim());
    }
  }

  async fetchSubjects() {
    this.isLoading = true;
    this.availSubjects = await getAllSubjects();
    this.isLoading = false;
  }

  async fetchPreCollection(uuid: string) {
    this.isLoading = true;

    try {
      this.currentPreCollection = await getPreCollectionByUuid(uuid);
    } catch (err) {
      if (err) {
        this.$toasted.global.mainToast({
          message: 'Pre collection not found',
        });
        this.$router.push({ name: 'pre-collection' });
      }
    }
    this.isLoading = false;
  }

  async submitForm() {
    if (this.isLoading) return;
    this.isLoading = true;

    const params: CreatePreCollectionParam = {
      name: this.nameInput,
      description: this.descriptionInput,
      details: this.detailsInput,
      type: this.typeInput,
      thumbnail: this.thumbnailInput,
      form: this.getLevel(this.formInput),
      year: this.yearInput,
      subjectUuid: this.subjectUuidInput,
      pdfLink: this.pdfLinkInput,
      pdfLinkPreview: this.pdfLinkPreviewInput,
      collectionUuid: this.collectionUuidInput,
      totalQuestions: this.totalQuestionsInput,
      isPremium:
        this.isPremium === 'Premium'
          ? true
          : this.isPremium === 'Free'
          ? false
          : false,
      isDraft: false,
    };

    try {
      const newPreCollection = await createPreCollection(params);
      if (newPreCollection) {
        this.currentPreCollection = newPreCollection;

        this.$toasted.global.mainToast({
          message: 'New pre collection created',
        });

        this.$router.push(`/pre-collection/${newPreCollection.uuid}`);
      }
    } catch (error) {
      const err: ErrorResponse = error as any;
      if (err.errors && err.errors.length) {
        this.$toasted.global.mainToast({
          message: `ERROR: ${JSON.stringify(err.errors[0])}`,
        });
      } else {
        this.$toasted.global.mainToast({
          message: `ERROR: ${err.message}`,
        });
      }
    }

    this.isLoading = false;
  }

  async updatePreCollection() {
    if (!this.currentPreCollection) return;

    if (this.isLoading) return;
    this.isLoading = true;

    const params: CreatePreCollectionParam = {
      name: this.nameInput,
      description: this.descriptionInput,
      details: this.detailsInput,
      type: this.typeInput,
      thumbnail: this.thumbnailInput,
      form: this.getLevel(this.formInput),
      year: this.yearInput,
      subjectUuid: this.subjectUuidInput,
      pdfLink: this.pdfLinkInput,
      pdfLinkPreview: this.pdfLinkPreviewInput,
      collectionUuid: this.collectionUuidInput,
      totalQuestions: this.totalQuestionsInput,
      isPremium:
        this.isPremium === 'Premium'
          ? true
          : this.isPremium === 'Free'
          ? false
          : false,
      isDraft: false,
    };

    try {
      const newPreCollection = await updatePreCollectionByUuid(
        this.currentPreCollection.uuid,
        params,
      );
      if (newPreCollection) {
        this.currentPreCollection = newPreCollection;

        this.$toasted.global.mainToast({
          message: 'Pre collection created updated',
        });
      }
    } catch (error) {
      const err: ErrorResponse = error as any;
      if (err.errors && err.errors.length) {
        this.$toasted.global.mainToast({
          message: `ERROR: ${JSON.stringify(err.errors[0])}`,
        });
      } else {
        this.$toasted.global.mainToast({
          message: `ERROR: ${err.message}`,
        });
      }
    }

    this.isLoading = false;
  }

  async deletePreCollection() {
    if (!this.currentPreCollection) return;

    if (this.isLoading) return;
    this.isLoading = true;

    try {
      await deletePreCollectionByUuid(this.currentPreCollection.uuid);
      this.currentPreCollection = null;

      if (this.$router.currentRoute.name !== 'pre-collection') {
        this.$router.push({ name: 'pre-collection' });
      }

      this.resetForm();
    } catch (error) {
      const err: ErrorResponse = error as any;
      if (err.errors && err.errors.length) {
        this.$toasted.global.mainToast({
          message: `ERROR: ${JSON.stringify(err.errors[0])}`,
        });
      } else {
        this.$toasted.global.mainToast({
          message: `ERROR: ${err.message}`,
        });
      }
    }

    this.isLoading = false;
  }

  resetForm() {
    this.nameInput = '';
    this.descriptionInput = '';
    this.detailsInput = '';
    this.typeInput = PreCollectionType.Exam;
    this.formInput = this.generateLevel(9);
    this.yearInput = 2021;
    this.subjectUuidInput = 'sejarah';
    this.pdfLinkInput = '';
    this.pdfLinkPreviewInput = '';
    this.collectionUuidInput = '';
  }
}
